import { gql } from "apollo-boost";
import Error from 'components/alerts/Error';
import Success from 'components/alerts/Success';
import { Card } from 'components/common/card/Card';
import { TextArea } from 'components/common/form/modules/input/TextArea';
import { createTicketBankItem, disable, getTicketBankItemsAsString, updateQuantity } from 'components/graphql/queries/ticketBank';
import { closeModal, openModal } from 'components/modal/modules/dispatcher/methods';
import { AppConfig } from 'config/app';
import * as JSCookie from 'js-cookie';
import TicketInventoryTableHeader from 'pages/manage/events/edit/modules/ticketInventory/modules/TicketInventoryTableHeader';
import React from 'react';
import { Subscription } from "react-apollo";
import { connect } from 'react-redux';
import Switch from 'react-switch'
import { CardHeader } from 'reactstrap';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UsersDucks from 'stores/ducks/Users.duck';

import { deleteTicketItem } from '../../../../../../components/graphql/queries/ticketBank';
import CreateTicketModal from './modules/CreateTicketModal';
import TicketInventoryItem from './modules/TicketInventoryItem';

import CustomizeSubdomain from './CustomizeSubdomain'

import { getUsers } from 'components/graphql/queries';

enum TicketInventoryDomain {
  PUBLIC = "public",
  PRIVATE = "private"
}

class PublicTicketInventoryTab extends React.Component<
  {
    ticketInventory: any;
    promoters: any;
    users: any;
    dispatch: any;
    eventId: string;
    currency: string;
    capacity: number;
  },
  {
    [label: string]: any;
  }
  > {
  constructor(props) {
    super(props);

    // Handlers..
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleEnabled = this.handleEnabled.bind(this);
    this.handleModalInputChange = this.handleModalInputChange.bind(this);
    this.handleCreateItem = this.handleCreateItem.bind(this);
    this.handleOpenCreateModal = this.handleOpenCreateModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleTeamNewUserChange = this.handleTeamNewUserChange.bind(this);
    this.customizeSubdomain = this.customizeSubdomain.bind(this);
    // Other methods..
    this.mapTicketInventoryState = this.mapTicketInventoryState.bind(this);
    this.findTicketInventoryItemByIndex = this.findTicketInventoryItemByIndex.bind(this);
    this.reloadData = this.reloadData.bind(this);
    this.updateEmails = this.updateEmails.bind(this);
    this.onChangeGeneralLinkAvailable = this.onChangeGeneralLinkAvailable.bind(this);
    this.selectPromoter = this.selectPromoter.bind(this);
    this.changeFullView = this.changeFullView.bind(this);
    this.changeAllocateIndividually = this.changeAllocateIndividually.bind(this);

    // We need to set default state, and merge it with props..
    this.state = {
      userIds: [],
      ticketInventoryPublic: [],
      ticketInventoryPrivate: [],
      generalLinkViews: 0,
      ticketInventoryMap: {},
      ticketInventoryPromoterMap: {},
      ticketInventoryNew: {
        name: null,
        quantity: 0,
        promoterId: null,
        price: 0,
        isChanged: true,
        description: null,
        availableOnGeneralLink: true,
        accessibleTo: []
      },
      allocateIndividually: false,
      fullView: false,
      modifier: false,
      capacityRemaining: 0,
      updateString: null,
      code: '',
      customSubdomain: '',
      updateString1: null,
      updateString2: null,
      updateString3: null,
      restrictedEmails: '',
      emailsChanged: false,
      emailsUpdated: false,
      invalidEmail: false,
      ...props
    };
  }

  public componentDidMount() {
    const { eventId } = this.props;
    fetchGraphQL(getTicketBankItemsAsString(), JSCookie.get("token"), {
      eventId
    }).then((resultInventory: any) => {
      const eventTicketInventory: any[] = JSON.parse(resultInventory.ticketBank.getAsString) || [];

      let ids: string[] = []
      fetchGraphQL(`
      query {
        event {
          get(eventId:"${eventId}") {
            hosts
            promoters
            checkers
          }
        }
      }
      `).then(userRes => {
        ids = [
          ...userRes.event.get.hosts,
          ...userRes.event.get.promoters,
          ...userRes.event.get.checkers
        ]
        fetchGraphQL(getUsers(), JSCookie.get("token"), {
          ids
        }).then((res: any) => {
          this.mapTicketInventoryState(eventTicketInventory, res.user.findByIds);
        })
      })
    });

    fetchGraphQL(`
    query {
      url {
        get(eventId: "${eventId}") {
          code
          generalLinkViews
          customSubdomain
        }
      }
    }
    `).then(res => {
      console.log(res.url.get.customSubdomain)
      this.setState({
        code: res.url.get.code,
        generalLinkViews: res.url.get.generalLinkViews ? res.url.get.generalLinkViews : 0,
        customSubdomain: res.url.get.customSubdomain ? res.url.get.customSubdomain : ''
      })
    })

    fetchGraphQL(`query {
      restrictedEmails {
        getRestrictedEmails(eventId:"${this.props.eventId}")
      }
    }`).then(res => {

      const emails = res.restrictedEmails.getRestrictedEmails.split(',');
      let restrictedEmails = '';
      // console.log(emails)

      emails.map((obj, index) => {
        if (index === emails.length - 1) {
          restrictedEmails += obj;
        } else {
          restrictedEmails += (obj + '\n');
        }
      })

      // console.log(restrictedEmails)
      this.setState({
        restrictedEmails: restrictedEmails || ""
      })

    })
  }

  public changeFullView() {
    this.setState({
      fullView: !this.state.fullView
    })
  }

  public customizeSubdomain() {
    const content = <CustomizeSubdomain
      general={true}
      subdomain={this.state.customSubdomain}
      eventId={this.props.eventId}
    />
    openModal(content, "Customize General Link", [
    ]);
  }

  public updateEmails() {
    const stringArray = this.state.restrictedEmails.split('\n');
    const emails: any[] = []

    stringArray.map(item => {
      const email = item.trim();
      // Heavy validation
      if (email !== null && email !== undefined && email !== "" && email.length !== 0 && !emails.includes(email) && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        emails.push(email)
      }
    })

    // Removed adding an error. Instead, just filter out the data from the beginning and pass it then
    fetchGraphQL(`
      mutation {
        restrictedEmails {
          updateRestrictedEmails(eventId:"${this.props.eventId}",emails:"${emails.toString()}")
        }
      }
    `).then(res => {
      // console.log(res)
      this.setState({
        emailsChanged: false,
        emailsUpdated: true
      })
    })
  }

  public reloadData(updateNum: any, num: number) {

    if (num === 1) {
      this.setState({ updateString: updateNum })
    } else if (num === 2) {
      this.setState({ updateString1: updateNum })
    } else if (num === 3) {
      this.setState({ updateString2: updateNum })
    } else if (num === 4) {
      this.setState({ updateString3: updateNum })
    }

    const { eventId } = this.props;

    fetchGraphQL(getTicketBankItemsAsString(), JSCookie.get("token"), {
      eventId
    }).then((resultInventory: any) => {
      const eventTicketInventory: any[] = JSON.parse(resultInventory.ticketBank.getAsString) || [];

      let ids: string[] = [];
      fetchGraphQL(`
      query {
        event {
          get(eventId:"${eventId}") {
            hosts
            promoters
            checkers
          }
        }
      }
      `).then(userRes => {
        ids = [
          ...userRes.event.get.hosts,
          ...userRes.event.get.promoters,
          ...userRes.event.get.checkers
        ]
        fetchGraphQL(getUsers(), JSCookie.get("token"), {
          ids
        }).then((res: any) => {
          this.mapTicketInventoryState(eventTicketInventory, res.user.findByIds);
        })
      })
    });

    return undefined;
  }
  /**
   * Used to map received props from parent - ticketInventoryItems
   * to state, and create "hashMap" -> ID : Index
   */
  public mapTicketInventoryState(eventTicketInventory: any[], userIds: string[]) {
    const { props } = this;
    const ticketInventory: { public: any[]; private: any[] } = {
      public: [],
      private: []
    };

    let totalAllocatedTicket = 0;
    eventTicketInventory.forEach((titem: any) => {
      totalAllocatedTicket += (titem.quantity === -1 ? titem.bought + titem.activated : titem.quantity);
      const { promoterId, referral } = titem;
      if (promoterId === undefined || promoterId === null) {
        ticketInventory.public.push(titem);
      } else {
        if (referral !== true) {
          ticketInventory.private.push(titem);
        }
      }
    });

    // Map for key: _id val: index in array - public / private key of ticketInventory state
    const ticketInventoryMap: { private: any; public: any } = {
      private: {},
      public: {}
    };

    const ticketInventoryPromoterMap: any = {};

    // Building hashmap : id  --> <-- Index
    ticketInventory.public.forEach((val: any, index: number) => {
      ticketInventoryMap.public[val._id] = index;
    });
    ticketInventory.private.forEach((val: any, index: number) => {
      ticketInventoryMap.private[val._id] = index;
      // if promoter id is not in map...
      if (!ticketInventoryPromoterMap[val.promoterId]) {
        ticketInventoryPromoterMap[val.promoterId] = [];
      }
      // if ticket is not in promoter's array map
      if (ticketInventoryPromoterMap[val.promoterId].indexOf(val._id) === -1) {
        ticketInventoryPromoterMap[val.promoterId].push(val._id);
      }
    });

    const capacityRemaining = props.capacity - totalAllocatedTicket < 0 ? 0 : props.capacity - totalAllocatedTicket;

    // set to state
    this.setState({
      ticketInventoryPublic: ticketInventory.public,
      ticketInventoryPrivate: ticketInventory.private,
      ticketInventoryMap,
      ticketInventoryPromoterMap,
      capacityRemaining,
      userIds
    });

  }

  public findTicketInventoryItemByIndex(
    id: string
  ): { domain: TicketInventoryDomain; index: number; quantity: number } {
    const { ticketInventoryMap } = this.state;
    let quantity = 0;
    this.props.ticketInventory.forEach((titem: any) => {
      if (titem._id === id) {
        quantity = titem.quantity;
      }
    });
    if (ticketInventoryMap.public[id] !== undefined) {
      return {
        domain: TicketInventoryDomain.PUBLIC,
        index: ticketInventoryMap.public[id],
        quantity
      };
    } else if (ticketInventoryMap.private[id] !== undefined) {
      return {
        domain: TicketInventoryDomain.PRIVATE,
        index: ticketInventoryMap.private[id],
        quantity
      };
    }
    return {
      domain: TicketInventoryDomain.PUBLIC,
      index: -1,
      quantity,
    };
  }

  /**
   * Handles quantity change of ticket inventory item.
   *
   * @param payload
   */
  public handleQuantityChange(payload: { _id: string; quantity: number }) {
    // Cannot exceed the event capacity
    if (this.state.capacityRemaining - payload.quantity < 0) {
      return;
    }

    const { ticketInventoryPublic } = this.state;
    const ticketIndex = this.findTicketInventoryItemByIndex(payload._id);

    // Simple wrapped fetch to graphql, to minimize repetetivity,
    // But there is also the more elegant way to refactor this :)
    const doRequestWrapped = (id: string, quantity: number): Promise<any> => {
      return fetchGraphQL(updateQuantity(), undefined, {
        ticketBankItem: {
          _id: id,
          quantity,
          eventId: this.props.eventId
        }
      });

    };

    doRequestWrapped(
      ticketInventoryPublic[ticketIndex.index]._id,
      ticketInventoryPublic[ticketIndex.index].quantity + payload.quantity
    ).then((value: any) => {
      const response = value.ticketBank.update;
      ticketInventoryPublic[ticketIndex.index].quantity = response.quantity;
      this.setState({
        ticketInventoryPublic,
        modifier: true,
        capacityRemaining: this.state.capacityRemaining - payload.quantity
      });
    });

  }

  /**
   * Used to enable / disable ticket inventory item
   *
   * @param payload payload is used for update query
   */
  public handleEnabled(payload: { _id: string; enabled: boolean }) {
    const { _id, enabled } = payload;

    const ticketIndex = this.findTicketInventoryItemByIndex(payload._id);

    fetchGraphQL(disable(), undefined, {
      ticketBankItem: {
        _id,
        enabled
      }
    }).then((value: any) => {
      // const response = value.ticketBank.update;
      const { ticketInventoryPublic, ticketInventoryPrivate } = this.state;
      switch (ticketIndex.domain) {
        case TicketInventoryDomain.PUBLIC:
          ticketInventoryPublic[ticketIndex.index].enabled = enabled;
          this.setState({ ticketInventoryPublic });
          break;
        case TicketInventoryDomain.PRIVATE:
          ticketInventoryPrivate[ticketIndex.index].enabled = enabled;
          this.setState({ ticketInventoryPrivate });
          break;
      }
    });
  }

  /**
   * Used to delete ticket inventory item
   *
   * @param payload payload is used for update query
   */
  public handleDelete(payload: { _id: string }) {
    const { _id } = payload;
    fetchGraphQL(deleteTicketItem(), undefined, {
      ticketBankItem: {
        _id,
        eventId: this.props.eventId
      }
    }).then((value: any) => {
      this.reloadData(Math.random(), 1);
    });
  }

  /**
   * Handles creation of item, and also on finish, it adds the item into state.
   */
  public handleCreateItem(e: any) {
    e.preventDefault();
    const {
      ticketInventoryNew,
      // ticketInventoryMap,
      // ticketInventoryPublic,
      // ticketInventoryPrivate
    } = this.state;
    if (ticketInventoryNew.name === null || ticketInventoryNew.name === "") {
      return;
    }
    if (ticketInventoryNew.price === null || ticketInventoryNew.price === "") {
      return;
    }
    if (ticketInventoryNew.quantity === null || ticketInventoryNew.quantity === "") {
      return;
    }

    // Make wsure here the numbers are being stored correctly

    // ticketInventoryNew.price = ticketInventoryNew.price * 100;
    ticketInventoryNew.quantity = Number(ticketInventoryNew.quantity);

    if (ticketInventoryNew.quantity > this.state.capacityRemaining) {
      return;
    }

    // New check -- ticket needs to be allocated to something !!
    if (ticketInventoryNew.availableOnGeneralLink === false && ticketInventoryNew.accessibleTo.length === 0) {
      return;
    }

    delete ticketInventoryNew.isChanged;
    fetchGraphQL(createTicketBankItem(), undefined, {
      ticketBankItem: {
        ...ticketInventoryNew,
        price: ticketInventoryNew.price * 100,
        eventId: this.props.eventId,
        promoterId: undefined,
        description: ticketInventoryNew.description ? ticketInventoryNew.description : null
      },
      allocateIndividually: this.state.allocateIndividually ? true : false
    }).then(ticketBank => {
      this.reloadData(Math.random(), 1);
    });
  }

  /**
   * Handle input changes in modal...
   */
  public handleModalInputChange(e: any) {
    const { value, name } = e.target;
    if (name === 'quantity' && isNaN(Number(value))) {
      e.target.setCustomValidity("Input type should be a number");
      return;
    }
    if (name === 'price' && isNaN(Number(value))) {
      e.target.setCustomValidity("Input type should be a number");
      return;
    }
    if (name === "quantity" && Number(value) > this.state.capacityRemaining) {
      e.target.setCustomValidity("Ticket quantity must be less than or equal to the remaining event capacity (" + this.state.capacityRemaining + ")");
      return;
    }

    const temp = JSON.parse(JSON.stringify(this.state.ticketInventoryNew));
    temp[e.target.name] = e.target.value;
    this.setState({
      ticketInventoryNew: temp
    });
  }

  /**
   * Handle closing the modal once its use is out 
   */
  public handleCloseModal() {
    // console.log("progress")
    this.setState({
      ticketInventoryNew: {
        name: null,
        quantity: null,
        promoterId: null,
        description: null,
        availableOnGeneralLink: true,
        accessibleTo: []
      }
    });
    closeModal();
  }

  /**
   * used to create private / public ticket inv. item
   *
   * @param type public / private
   */
  public handleOpenCreateModal(
    type: TicketInventoryDomain = TicketInventoryDomain.PUBLIC
  ) {
    this.setState({
      ticketInventoryNew: {
        name: null,
        quantity: null,
        price: null,
        promoterId: null,
        description: null,
        availableOnGeneralLink: true,
        accessibleTo: []
      },
    });

    // To render inside the modal 
    const { eventId } = this.props;
    fetchGraphQL(getTicketBankItemsAsString(), JSCookie.get("token"), {
      eventId
    }).then((resultInventory: any) => {
      const eventTicketInventory: any[] = JSON.parse(resultInventory.ticketBank.getAsString) || [];

      let ids: string[] = []
      fetchGraphQL(`
      query {
        event {
          get(eventId:"${eventId}") {
            hosts
            promoters
            checkers
          }
        }
      }
      `).then(userRes => {
        ids = [
          ...userRes.event.get.hosts,
          ...userRes.event.get.promoters,
          ...userRes.event.get.checkers
        ]
        fetchGraphQL(getUsers(), JSCookie.get("token"), {
          ids
        }).then((res: any) => {
          this.mapTicketInventoryState(eventTicketInventory, res.user.findByIds);
          const content = (
            <CreateTicketModal
              ticketType={type}
              privateAdd={false}
              remainingCapacity={this.state.capacityRemaining}
              onChange={this.handleModalInputChange}
              onClose={this.handleCloseModal}
              onCreate={this.handleCreateItem}
              eventId={eventId}
              currency={this.props.currency}
              onChangeGeneralLinkAvailable={this.onChangeGeneralLinkAvailable}
              generalLinkShow={this.state.ticketInventoryNew.availableOnGeneralLink}
              users={this.state.userIds}
              selectPromoter={this.selectPromoter}
              changeAllocateIndividually={this.changeAllocateIndividually}
            />
          );
          openModal(content, "Allocate Tickets", [
          ]);
        })
      })
    });
  }

  public onChangeGeneralLinkAvailable() {
    this.setState({
      ticketInventoryNew: {
        ...this.state.ticketInventoryNew,
        availableOnGeneralLink: !this.state.ticketInventoryNew.availableOnGeneralLink
      }
    })
  }

  public changeAllocateIndividually() {
    this.setState({
      allocateIndividually: !this.state.allocateIndividually
    })
  }

  public selectPromoter(selected: string[]) {
    this.setState({
      ticketInventoryNew: {
        ...this.state.ticketInventoryNew,
        accessibleTo: selected
      }
    })
  }

  public handleTeamNewUserChange(e: any) {
    this.setState({
      restrictedEmails: e.target.value,
      emailsChanged: true,
      emailsUpdated: false,
      invalidEmail: false
    });
  }

  public render() {

    const divKey = JSON.parse(JSON.stringify(this.state))
    delete divKey.ticketInventoryNew;

    const ticketInventoryUpdate = gql`
      subscription {
        updatedTicketInventory(eventId:"${this.props.eventId}")
      }
      `;

    const ticketPurchase = gql`
      subscription {
        ticketPurchase(eventIds:"${this.props.eventId}")
      }
      `;

    const eventInformationUpdate = gql`
		subscription {
			eventDetailsUpdated(eventId:"${this.props.eventId}")
		}
		`;

    const ticketCheckin = gql`
      subscription {
        ticketCheckin(eventIds:"${this.props.eventId}")
      }
      `;

    const {
      ticketInventoryPublic,
      ticketInventoryPrivate
    } = this.state;

    const ticketInventory = [...ticketInventoryPublic, ...ticketInventoryPrivate]

    const generalLink = AppConfig.hostUrl === 'https://platform.isotopeticketing.com' ? 'http://istkt.com/event-' + this.state.code
      : AppConfig.hostUrl + "/event-" + this.state.code

    const finalGeneralURL = this.state.customSubdomain === '' ? generalLink : 'https://' + this.state.customSubdomain + '.isotopeticketing.com'
    console.log(finalGeneralURL)

    return (
      <div>
        <div>
          <Subscription subscription={ticketInventoryUpdate}>
            {({ data }) => {
              if (data !== undefined && data !== null && data.updatedTicketInventory !== null) {
                if (data.updatedTicketInventory !== this.state.updateString) {
                  return <img height={0} width={0} onLoad={this.reloadData(data.updatedTicketInventory, 1)} style={{ display: 'none' }} />
                }
                return null;
              }
              return null;
            }}
          </Subscription>
          <Subscription subscription={eventInformationUpdate}>
            {({ data }) => {
              if (data !== undefined && data !== null && data.eventDetailsUpdated !== null) {
                if (data.eventDetailsUpdated !== this.state.updateString1) {
                  return <img height={0} width={0} onLoad={this.reloadData(data.eventDetailsUpdated, 2)} style={{ display: 'none' }} />
                }
              }
              return null;
            }}
          </Subscription>
          <Subscription subscription={ticketCheckin}>
            {({ data }) => {
              if (data !== undefined && data !== null && data.ticketCheckin !== null) {
                if (data.ticketCheckin !== this.state.updateString2) {
                  return <img height="0" width="0" style={{ display: 'none' }} onLoad={this.reloadData(data.ticketCheckin, 3)} />
                }
                return null;
              }
              return null;
            }}
          </Subscription>
          <Subscription subscription={ticketPurchase}>
            {({ data }) => {
              if (data !== undefined && data !== null && data.ticketPurchase !== null) {
                if (data.ticketPurchase !== this.state.updateString3) {
                  return <img height="0" width="0" style={{ display: 'none' }} onLoad={this.reloadData(data.ticketPurchase, 4)} />
                }
                return null;
              }
              return null;
            }}
          </Subscription>
          <p />
        </div>
        <Card >
          <CardHeader style={{ borderTopLeftRadius: '15px', borderTopRightRadius: '15px', backgroundColor: '#f1f1f1', border: 'none' }}>
            <div style={{ width: '100%' }}>
              <div style={{ float: 'left', paddingLeft: '30px', lineHeight: '38px', paddingTop: '10px', color: '#f8f8f8' }}>
                <h3>Ticket Inventory</h3>
                <div>
                  <span>
                    <a
                      href={finalGeneralURL}
                      className='new-button-white-4'
                      style={{ fontSize: '17px', paddingLeft: '2px' }}
                    >
                      {this.state.customSubdomain === '' ? 'General Link' : this.state.customSubdomain + '.isotopeticketing.com'}
                    </a>
                  </span>
                  <span>
                    <button className='new-button-white-4' onClick={this.customizeSubdomain}>
                      &nbsp;&nbsp;Customize
                  </button>
                  </span>
                  <div className='sexyBlack' style={{ fontSize: '17px' }}>
                    &nbsp;&nbsp;&nbsp;{this.state.generalLinkViews === 1 ? '(' + this.state.generalLinkViews + ' VIEW)' : '(' + this.state.generalLinkViews + ' VIEWS)'}
                  </div>
                </div>
                <div>
                  <div style={{ flexDirection: 'row', paddingTop: '15px' }}>
                    <div style={{ float: 'left' }}>
                      <Switch
                        checked={this.state.fullView}
                        onChange={this.changeFullView}
                        onColor="#4d5adf"
                        onHandleColor="#ffffff"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={true}
                        boxShadow="0 2px 1px -1px gray"
                        height={25}
                        width={50}
                        className="react-switch"
                        id="material-switch"
                      />
                    </div>
                    <div className="sexyBlack" style={{ float: 'left', paddingLeft: '18px', fontWeight: 'bold', lineHeight: '25px' }}>
                      Detailed View
                  </div>
                  </div>
                </div>
              </div>
              <div style={{ float: 'right', paddingTop: '5px' }}>
                <button
                  className="new-button-save"
                  onClick={e =>
                    this.handleOpenCreateModal(TicketInventoryDomain.PUBLIC)
                  }
                  style={{ border: 'none' }}
                >
                  +
                </button>

              </div>
            </div>
          </CardHeader>
          <div
            key={JSON.stringify(divKey)}
            className="horizontal-scroll-only"
            style={{
              overflowX: "auto",
            }}
          >
            <table className="w-100 table-responsive--base" style={{ minWidth: this.state.fullView ? "1250px" : "1000px", position: "relative" }} >
              {
                ticketInventory.length > 0 ? <TicketInventoryTableHeader type={"public"} public={true} fullView={this.state.fullView} /> : null
              }
              <tbody style={{ minHeight: '300px', minWidth: this.state.fullView ? "1250px" : "1000px" }}>
                {ticketInventory.length > 0 ? (
                  ticketInventory.map((titem: any) => {
                    if (titem.referral) {
                      return null;
                    }
                    return (
                      <TicketInventoryItem
                        type={
                          titem.promoterId !== undefined && titem.promoterId !== null ?
                            "private" : "public"
                        }
                        key={"tinv-item-" + titem._id}
                        onAdd={this.handleQuantityChange}
                        onSubstract={this.handleQuantityChange}
                        onEnable={this.handleEnabled}
                        onDisable={this.handleEnabled}
                        onDelete={this.handleDelete}
                        data={titem}
                        reloadOnSave={this.reloadData}
                        ticketInventory={ticketInventory}
                        currency={this.props.currency}
                        capacityRemaining={this.state.capacityRemaining}
                        description={titem.description ? titem.description : null}
                        users={this.state.userIds}
                        fullView={this.state.fullView}
                      />
                    );
                  })
                ) : (
                    <tr>
                      <td colSpan={7} className="text-center">
                        No tickets created yet.
                    </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
          {
            ticketInventory.length > 0 ?
              <p style={{ width: '100%', textAlign: 'center', fontSize: '12px' }}>
                &infin; Sell until event capacity is reached.
              </p>
              : null
          }
        </Card>
        <p><br /></p>
        {
          this.state.fullView ?
            <>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Card style={{ width: '70%', minWidth: '350px' }}>
                  <p />
                  <p />
                  <h4 className="sexyBlack" style={{ textAlign: 'center' }}>Buyer Email Restriction</h4>
                  <h6 className="sexyBlack" style={{ textAlign: 'center' }}>(General Link Only)</h6>
                  <p />
                  <div style={{ paddingRight: '10%', paddingLeft: '10%' }}>
                    <TextArea
                      label={"Restricted e-mails"}
                      name="emails"
                      value={this.state.restrictedEmails || ''}
                      onChange={this.handleTeamNewUserChange}
                      infoMessage={
                        "OPTIONAL. One e-mail per line. Only the given email IDs will be permitted to buy public tickets. If no emails are entered, anyone will be able to buy public tickets."
                      }
                    />
                  </div>
                  <p><br /></p>
                  <div style={{ textAlign: 'center', width: '100%' }}>
                    <div >
                      <button
                        className='new-button-blue-outline'
                        onClick={e => {
                          e.preventDefault();
                          this.updateEmails();
                        }}
                        disabled={!this.state.emailsChanged || this.state.invalidEmail}
                      >
                        Update
              </button>
                      <p>
                        <br />
                        {
                          this.state.emailsUpdated ?
                            <div style={{ justifyContent: 'center', display: 'flex' }}>
                              <div style={{ maxWidth: '400px' }}>
                                <Success content="Emails updated" />
                              </div>
                            </div>
                            : null
                        }
                        {
                          this.state.invalidEmail ?
                            <div style={{ justifyContent: 'center', display: 'flex' }}>
                              <div style={{ maxWidth: '400px' }}>
                                <Error content="Invalid email entries, check given input" />
                              </div>
                            </div>
                            : null
                        }
                      </p>
                    </div>
                  </div>
                  <p />
                </Card>
              </div>
              <p><br /></p>
            </>
            : null
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    users: UsersDucks.getUsers(state)
  };
};

export default connect(mapStateToProps)(PublicTicketInventoryTab);



// WEBPACK FOOTER //
// ./src/pages/manage/events/edit/modules/ticketInventory/GeneralTicketInventoryTab.tsx